/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Nie znaleziono strony",
  "ComingSoon": "Już wkrótce",
  "YesanPersonalFinance": "Yesan, Finanse osobiste",
  "Yesan": "Yesan",
  "PersonalFinance": "Finanse osobiste",
  "YesanDownload": "Yesan Download",
  "ThisWebsiteUsesCookies": "Używamy plików cookie do zbierania i analizowania informacji o wydajności i użytkowaniu naszej witryny oraz do udostępniania funkcji mediów społecznościowych. Kontynuując, wyrażasz zgodę na nasze",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Stań się wolny finansowo",
  "inStepsAndActions": "w 8 krokach i 3 działaniach.",
  "TrackPlanAnalyze": "Śledź. Planuj. Analizuj.",
  "FTrack": "1. Śledzenie",
  "FPlan": "2. Planuj",
  "FAnalyze": "3. Analizuj",
  "Features": "Funkcje",
  "FeaturesSubHeading": "Czysty początkujący, już obeznany z finansami, jest to aplikacja, której potrzebujesz, aby stać się wolnym finansowo.",
  "ManageAccounts": "Zarządzaj kontami",
  "CashLiquidFixedAssetsLiabilities": "Gotówka, środki płynne, aktywa trwałe i zobowiązania.",
  "TrackTransactions": "Śledź transakcje",
  "IncomesExpensesTransferInvestments": "Przychody, wydatki, przelewy, inwestycje.",
  "ImportExport": "Import / Eksport",
  "YourDataAlwaysAccessible": "Twoje dane zawsze dostępne.",
  "PlanYourFreedom": "Zaplanuj swoją wolność",
  "StepsAwayFromFI": "8 kroków od niezależności finansowej.",
  "BudgetsAndGoals": "Budżety i cele",
  "CheckYourProgressAndAchieve": "Sprawdzaj swoje postępy i osiągaj cele finansowe.",
  "DashboardAndAnalytics": "Pulpit nawigacyjny i analityka",
  "ReviewLearnOptimizeWith": "Przeglądaj, ucz się, optymalizuj dzięki wykresom, statystykom i narzędziom.",
  "Security": "Bezpieczeństwo",
  "MilitaryGradeEncryption": "Szyfrowanie klasy wojskowej, obsługa biometrii, dane przechowywane na urządzeniach.",
  "OfflineMode": "Tryb offline",
  "YourDataAlwaysAccessibleAndModif": "Dane zawsze dostępne i modyfikowalne.",
  "Track": "Śledzenie",
  "Income": "Dochód",
  "Expense": "Wydatki",
  "Transfer": "Transfer",
  "transactionsAndManageAccounts": "i zarządzaj różnymi kontami:",
  "checkings": "Sprawdzanie",
  "savings": "Oszczędności",
  "realEstate": "Nieruchomości",
  "stocks": "Rynki akcji",
  "bonds": "Obligacje",
  "crypto": "Kryptowaluty",
  "notes": "Banknoty, portfel gotówkowy",
  "envelopes": "Koperty",
  "privateEquity": "Private Equity",
  "metal": "Metal",
  "retirement": "Emerytura",
  "lifeInsurance": "Ubezpieczenie na życie",
  "intellectualProperty": "Własność intelektualna",
  "otherLiquidAsset": "Inne aktywa płynne",
  "otherFixedAsset": "Inne aktywa trwałe",
  "mortgage": "Hipoteka",
  "loan": "Pożyczka konsumencka",
  "creditCard": "Karta kredytowa",
  "otherLiability": "Inne zobowiązania",
  "AccountsManagement": "Zarządzanie kontami",
  "MultipleAccountsTypesAndGrouping": "Wiele typów kont i grupowanie",
  "LinkAccounts": "Łączenie kont z instytucji (dostępne tylko w niektórych krajach)",
  "SmartAccounts": "Inteligentne konta",
  "AddEditDeleteTransactions": "Dodawanie / edytowanie / usuwanie transakcji",
  "TickVerifiedTransactions": "Zaznacz zweryfikowane transakcje",
  "CategorizeTransactions": "Kategoryzowanie transakcji",
  "TagTransactions": "Oznaczanie transakcji",
  "TrackKakeiboType": "Śledzenie typu Kakeibo",
  "TrackInvestments": "Śledzenie inwestycji (dostępne tylko w niektórych krajach)",
  "ImportFromCSVFile": "Importuj transakcje w całości lub przyrostowo z pliku CSV",
  "ExportToCSVFile": "Eksport transakcji do pliku CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 kroków w kierunku planu niezależności finansowej, szczegółowe budżetowanie, szybsze osiąganie celów finansowych.",
  "levelsTowardsFI": "8 poziomów w kierunku niezależności finansowej",
  "EstablishBudgetsPer": "Ustalanie budżetów dla",
  "account": "konto",
  "accountType": "typ konta",
  "KakeiboType": "Typ Kakeibo",
  "category": "kategoria",
  "tag": "tag",
  "label": "etykieta",
  "TrackBudgetsPerFrequency": "Śledzenie budżetów według częstotliwości",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Tworzenie celów dotyczących wydatków, salda, przepływów pieniężnych, działań",
  "TrackGoalsProgress": "Śledzenie postępów w realizacji celów",
  "ReviewLearnOptimizeWithReportsCharts": "Przeglądaj, ucz się, optymalizuj dzięki raportom, wykresom, trendom, spostrzeżeniom, narzędziom.",
  "Dashboard": "Pulpit nawigacyjny",
  "FSNetWorth": "Sprawozdania finansowe: Wartość netto",
  "FSPnL": "Sprawozdania finansowe: Rachunek zysków i strat",
  "FSBalanceSheetAssetsLiabilities": "Sprawozdania finansowe: Bilans, aktywa, pasywa",
  "FSCashFlow": "Sprawozdania finansowe: Rachunek przepływów pieniężnych, debet, kredyt, przepływy",
  "FSFlows": "Sprawozdania finansowe: Przepływy",
  "FSRatios": "Sprawozdania finansowe: Wskaźniki",
  "TrendsMonthEnd": "Trendy na koniec miesiąca: Dochody i wydatki, Przepływy pieniężne",
  "TrendsPerformance": "Trendy wyników: YoY, MoM, WoW",
  "IncomeTrendsPer": "Trendy dochodu na",
  "SpendingTrendsPer": "Trendy wydatków na",
  "RecurringItemsIE": "Pozycje powtarzające się: Dochody i wydatki",
  "DebtProgressTrends": "Trendy postępu zadłużenia",
  "KakeiboMTDReviewTrends": "Kakeibo: Przegląd MTD, ostatni miesiąc, trendy",
  "FIWCLE": "Niezależność finansowa: Wykres ścienny, wydatki według energii życiowej",
  "DebtPaydownSnowballAvalanche": "Spłata zadłużenia: Kula śnieżna, Lawina",
  "FullyCustomizableAnalyticsRange": "W pełni konfigurowalny zakres czasowy analizy",
  "ContactUs": "Kontakt",
  "Privacy": "Prywatność",
  "Terms": "Warunki",
  "About": "Informacje",
  "IAgreeToThe": "Wyrażam zgodę na",
  "AndThe": "oraz",
  "PrivacyPolicy": "Polityka prywatności",
  "TermsOfUse": "Warunki użytkowania",

  "DigitalSoftwareExperienceTagline": "Oprogramowanie cyfrowe dla współczesnego świata",
  "DigitalExperience": "Cyfrowe doświadczenie",
  "SoftwareForTheModernWorld": "Oprogramowanie dla współczesnego świata",
  "MobileApplications": "Aplikacje mobilne",
  "forConnectedAndOfflineHumans": "dla ludzi połączonych i offline",
  "CloudSaaS": "SaaS w chmurze",
  "ResponsiveAndWebServices": "Usługi responsywne i internetowe",
  "PersonalFinanceServices": "Usługi finansów osobistych",
  "YS_p1": "Yesan to dynamiczna firma programistyczna specjalizująca się w tworzeniu najnowocześniejszych aplikacji mobilnych dostosowanych do potrzeb konsumentów. Dzięki doskonałemu zrozumieniu zmieniających się potrzeb i preferencji dzisiejszych zaawansowanych technologicznie użytkowników, Yesan poświęca się tworzeniu intuicyjnych, angażujących i bogatych w funkcje doświadczeń mobilnych, które wzbogacają życie użytkowników.",
  "YS_p2": "U podstaw misji Yesan leży nieustanne zaangażowanie w innowacje i kreatywność, a każdy produkt jest skrupulatnie opracowywany, aby zapewnić płynną funkcjonalność i wyjątkowe wrażenia użytkownika.",
  "PersonalFinanceApplication": "Aplikacja finansów osobistych",
  "YPF_p1": "Yesan, Personal Finance to najnowocześniejsza aplikacja mobilna do finansów osobistych, zaprojektowana w celu zapewnienia użytkownikom kompleksowych narzędzi do zarządzania finansami, wygodnie dostępnych na wyciągnięcie ręki. Dzięki eleganckiemu i intuicyjnemu interfejsowi, Yesan, Personal Finance oferuje holistyczne podejście do zarządzania finansami, zaspokajając potrzeby użytkowników na wszystkich poziomach wiedzy finansowej.",
  "YPF_p2": "Kluczowe funkcje obejmują śledzenie budżetu, kategoryzację wydatków i monitorowanie transakcji w czasie rzeczywistym, dzięki czemu użytkownicy mogą bez wysiłku uzyskać wgląd w swoje nawyki związane z wydatkami. Aplikacja oferuje również konfigurowalne opcje budżetowania, umożliwiając użytkownikom ustalanie celów finansowych i śledzenie ich postępów w czasie.",
  "YPF_p3": "Co więcej, Yesan, Personal Finance priorytetowo traktuje bezpieczeństwo, wykorzystując najnowocześniejsze protokoły szyfrowania w celu ochrony poufnych informacji finansowych użytkowników. Dzięki zabezpieczeniom na poziomie bankowym użytkownicy mogą bez obaw łączyć swoje konta i synchronizować transakcje bez narażania prywatności.",
  "YPF_p4": "Yesan, Personal Finance wykracza poza podstawowe budżetowanie, oferując wnikliwe analizy i spersonalizowane rekomendacje w celu optymalizacji decyzji finansowych. Niezależnie od tego, czy chodzi o identyfikację potencjalnych możliwości oszczędzania, monitorowanie portfeli inwestycyjnych, czy zarządzanie strategiami spłaty zadłużenia, aplikacja zapewnia dostosowany wgląd, aby pomóc użytkownikom osiągnąć ich cele finansowe.",
  "Discover": "Odkryj",
  "Firstname": "Imię",
  "Lastname": "Nazwisko",
  "Company":"Firma",
  "Subject": "Temat",
  "Email": "E-mail",
  "Message": "Wiadomość",
  "ThankYouForContactingUs": "Dziękujemy za skontaktowanie się z nami",
  "ValidFirstnameRequired": "Wymagane jest prawidłowe imię.",
  "ValidLastnameRequired": "Wymagane jest prawidłowe nazwisko.",
  "ValidEmailAddressRequired": "Wprowadź prawidłowy adres e-mail.",
  "ValidSubjectRequired": "Wybierz prawidłowy temat.",
  "ValidMessageRequired": "Wprowadź prawidłową wiadomość.",
  "UnableToSendTheFormPleaseRetryLater": "Nie można wysłać formularza, spróbuj ponownie później.",
  "Information": "Informacje",
  "Sales":"Sprzedaż",
  "Support": "Wsparcie",
  "Press": "Prasa",
  "Partnership": "Partnerstwo",
  "Other": "Inne",
  "Blog":"Blog",

  "Accept":"Akceptować",
  "Decline":"Odrzuć",

  "WorklogCalendar":"Kalendarz dziennika pracy dla Jira",

  "DirectlyAccessibleInProjectApps":"Bezpośredni dostęp w aplikacjach projektowych",
  "VisualizeWhereYouSpentYourTime":"Wizualizacja spędzonego czasu",
  "AllYourWorklogsInACalendar":"Wszystkie dzienniki robocze w kalendarzu",
  "MonthSummary":"Podsumowanie miesiąca",
  "CheckIfYouForgotToLogTime":"Sprawdź, czy nie zapomniałeś zarejestrować czasu.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Bezpośredni dostęp do spraw i aktualizacja czasu",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Kliknij element dziennika pracy, aby uzyskać bezpośredni dostęp do spraw i edytować zarejestrowany czas.",
  "AlsoAvailableInDarkMode":"Dostępne również w trybie ciemnym",
  "DirectlyLogWorkOnTheCalendarVisually":"Bezpośrednie wizualne rejestrowanie pracy w kalendarzu",
  "ClickOnTheCalendarToCreateNewWorklog":"Kliknij kalendarz, aby utworzyć nowy dziennik pracy",

  "AppsForAtlassian":"Aplikacje dla Atlassian",
  "YCL_p1":"Wizualizuj wszystkie swoje dzienniki robocze w kalendarzu z widokiem miesiąca, tygodnia, tygodnia roboczego i dnia.",
  "YCL_p2":"Rejestruj pracę bezpośrednio z kalendarza, wizualnie wybierając przedział czasowy.",
  "YCL_p3":"Zidentyfikuj, jeśli zapomniałeś śledzić czas w swoich kartach czasu pracy.",
  "YCL_p4":"Dostępne w językach: Angielski (Wielka Brytania), angielski (USA), chiński (uproszczony), chiński (tradycyjny), czeski, duński, holenderski, estoński, fiński, francuski, niemiecki, węgierski, islandzki, włoski, japoński, koreański, norweski, polski, portugalski (Brazylia), portugalski (Portugalia), rosyjski, hiszpański, szwedzki, turecki.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Portfel finansowy dla Jira",
  "BringRealFinancialPortfolio":"Wprowadź prawdziwe zarządzanie portfelem finansowym do Jira. Śledź budżety, nakłady inwestycyjne (CapEx) i koszty operacyjne (OpEx) oraz koszty projektów w jednym miejscu.",
  "YFPAboutQ":"Ile naprawdę kosztują nas nasze projekty w Jira?",
  "YFPAbout":"Portfel finansowy dla Jira\nKierownicy finansowi i biura PMO mają trudności z odpowiedzią na proste pytanie:\nIle naprawdę kosztują nas nasze projekty w Jira?\nJira śledzi pracę.\nFinanse śledzą budżety.\nTa aplikacja w końcu łączy te dwa elementy.\n\nPortfel finansowy zamienia Jira w lekką platformę PPM + planowania finansowego — bez potrzeby korzystania z drogich narzędzi korporacyjnych.",
  "YFPPorfolioQ":"Budżety portfela i śledzenie",
  "YFPPorfolioP":"Twórz portfele obejmujące wiele projektów Jira i definiuj: kwotę budżetu, walutę, zakres dat, uwzględnione projekty, zespoły. Śledź rzeczywiste koszty automatycznie w miarę postępu prac w Jira.",
  "YFPPorfolioListQ":"Portfele",
  "YFPPorfolioListP":"Twórz portfele finansowe łączące wiele projektów Jira i natychmiast przeglądaj: budżet a rzeczywiste koszty, tempo wydatkowania środków w czasie rzeczywistym, podział na CapEx i OpEx, koszt na zgłoszenie i projekt, raporty finansowe do eksportu. Wszystko oparte bezpośrednio na rejestrach pracy Jira.",
  "CostQ":"Automatyczne obliczanie kosztów",
  "CostP":"Zamień rejestrację czasu pracy w prawdziwe dane finansowe. Aplikacja: odczytuje dzienniki pracy Jira, stosuje stawki godzinowe, codziennie oblicza rzeczywiste koszty projektu. Bez arkuszy kalkulacyjnych. Bez ręcznej pracy.",
  "RatesQ":"Stawki",
  "RatesP":"Ustal stawkę godzinową dla projektu, zespołu lub globalnie",
  "ReportQ":"Raportowanie finansowe w formacie CSV",
  "ReportP":"Eksportuj dane finansowe portfela w kilka sekund. Idealne dla: zespołów finansowych, raportowania dla dyrektora finansowego, planowania budżetu, wsparcia audytowego",
  "SettingsQ": "Klasyfikacja CapEx vs OpEx",
  "SettingsP": "Wspieraj wymagania księgowe i audytowe. Klasyfikuj pracę na: prace rozwojowe podlegające kapitalizacji (CapEx), prace operacyjne (OpEx). Generuj raporty do eksportu gotowe dla zespołów finansowych."
};

export const documents = {
};
